
import { Base } from '../base-component';
import './file-list-filter-year.component.scss';

import * as $ from 'jquery';

export class FileListFilterYear extends Base {

	constructor(element: Element){

		super(element)
				
	}

		// values
		valueSort: any;
		valueDate: any;
		

		// selects
		selectContainer: any;
		selectSort: any;
		selectBox: any;
		selectBoxSort: any;
		selectBoxSortItem: any;

		selectDate: any;	
		selectBoxDate: any;
		selectBoxDateItem: any;

	init(){
		this.selectSort = this.element.querySelector('.js-select-sort');
		this.selectBox = this.element.querySelector('.file-list-filter-year__sort__form__select--box');
		this.selectBoxSort= Array.from(this.element.querySelectorAll('.file-list-filter-year__sort__form__select--box__button'));
		this.selectBoxSortItem = Array.from(this.element.querySelectorAll('.file-list-filter-year__sort__form__select--box__item'));

		this.selectDate = this.element.querySelector('.js-select-date');
		this.selectBox = this.element.querySelector('.file-list-filter-year__date__form__select--box');
		this.selectBoxDate= Array.from(this.element.querySelectorAll('.file-list-filter-year__date__form__select--box__button'));
		this.selectBoxDateItem = Array.from(this.element.querySelectorAll('.file-list-filter-year__date__form__select--box__item'));

	}

	changeSort(value: any) {
		console.log(value);
	}

	changeDate(value: any) {
		console.log(value);
	}
		
		
	bindEvents(){

		// desktop button
		this.selectBoxSort.map((item) => item.addEventListener('click', (event) => {
			let element = event.currentTarget;
			let parent = element.closest('.file-list-filter-year__sort__form__select__desktop-container');
			let box = parent.querySelector('.file-list-filter-year__sort__form__select--box');
			if(box.classList.contains('file-list-filter-year__sort__form__select--box__active')){
				box.classList.remove('file-list-filter-year__sort__form__select--box__active');
			}else{
				box.classList.add('file-list-filter-year__sort__form__select--box__active');
			}
		}));

		// desktop select
		this.selectBoxSortItem.map((item) => item.addEventListener('click', (event) => {
			let element = event.target;
			let dataName = element.getAttribute('data-name');
			let dataValue = element.getAttribute('data-value');
			let i;
			let parent = element.closest('.file-list-filter-year__sort__form__select');
			let select = parent.querySelector('select');
			for( i = 0; i < select.length; i++) { 
				if(select[i].value === dataValue) { 
					break; 
				} 
			}
			select.options.selectedIndex = i;
			let container = element.closest('.file-list-filter-year__sort__form__select__desktop-container');
			let button = container.querySelector('.file-list-filter-year__sort__form__select--box__button');
			let box = container.querySelector('.file-list-filter-year__sort__form__select--box');
			box.classList.remove('file-list-filter-year__sort__form__select--box__active');
			button.innerHTML = dataName;
			this.changeSort(select.value);

		}));

		// desktop button date
		this.selectBoxDate.map((item) => item.addEventListener('click', (event) => {
			let element = event.currentTarget;
			if(this.selectBox.classList.contains('file-list-filter-year__date__form__select--box__active')){
				this.selectBox.classList.remove('file-list-filter-year__date__form__select--box__active');
			}else{
				this.selectBox.classList.add('file-list-filter-year__date__form__select--box__active');
			}
		}));

		// desktop select
		this.selectBoxDateItem.map((item) => item.addEventListener('click', (event) => {
			let element = event.target;
			let dataName = element.getAttribute('data-name');
			let dataValue = element.getAttribute('data-value');
			let i;
			let parent = element.closest('.file-list-filter-year__date__form__select');
			let select = parent.querySelector('select');
			for( i = 0; i < select.length; i++) { 
				if(select[i].value === dataValue) { 
					break; 
				} 
			}
			select.options.selectedIndex = i;
			let container = element.closest('.file-list-filter-year__date__form__select__desktop-container');
			let button = container.querySelector('.file-list-filter-year__date__form__select--box__button');
			this.selectBox.classList.remove('file-list-filter-year__date__form__select--box__active');
			button.innerHTML = dataName;
			this.changeDate(select.value);

		}));
		
	}
}




// WEBPACK FOOTER //
// ./components/file-list-filter-year/file-list-filter-year.component.ts